module.exports = __webpack_public_path__ + "img/category_active.cb2cc09f.svg";